import { type Store } from "@/redux/store";

import { PageLoadStrategy, PageLoadStrategyDataArgument } from "./types";

export const handleLoadTask = async (
  task: PageLoadStrategy,
  data: PageLoadStrategyDataArgument
) => {
  try {
    return await task(data);
  } catch (error) {
    console.error("Page load common task error: ", error);
  }
};

export const getStoreMap = settings => {
  const storeMap = {};

  settings?.stores?.forEach(store => {
    let storeURL = store.name.toLowerCase();
    storeURL = storeURL.includes("toys") ? "toys" : storeURL.replace(/ /g, "-");

    storeMap[store.mid] = `/${storeURL}`;
  });

  return storeMap;
};

export const getStoreId = ({
  store,
  url
}: {
  store: Store;
  url: string;
}): string => {
  const country = store.getState().common.settings;

  let storeId = null,
    _bflStoreId = null,
    storeMap = getStoreMap({ stores: country?.stores });

  country?.stores?.forEach(item => {
    if (url.includes(storeMap[item.mid])) {
      storeId = item.mid;
    }
    if (item.name.toLocaleLowerCase().includes("brands")) {
      _bflStoreId = item.mid;
    }
  });

  return storeId || _bflStoreId;
};
